import { useEffect, type RefObject } from 'react'
import { useMedia } from './useMedia'

/**
 * As camadas do hero acompanham o mouse de leve, cada uma num ritmo.
 * Aqui o requestAnimationFrame e seguro: se o quadro nao rodar, a unica
 * consequencia e o desenho nao se mexer — nada fica invisivel.
 */
export function useParallax(ref: RefObject<HTMLElement>) {
  const { reduced, isTouch } = useMedia()

  useEffect(() => {
    const cena = ref.current
    if (!cena || reduced || isTouch) return

    let mx = 0
    let my = 0
    let quadro: number | null = null

    const desenhar = () => {
      const camadas = Array.from(cena.querySelectorAll<HTMLElement>('.phone, .hero__photo'))
      camadas.forEach((camada, i) => {
        const d = (i + 1) * 0.08
        camada.style.translate = `${(mx * d * 30).toFixed(2)}px ${(my * d * 24).toFixed(2)}px`
      })
      quadro = null
    }

    const aoMover = (e: MouseEvent) => {
      const r = cena.getBoundingClientRect()
      mx = (e.clientX - r.left) / r.width - 0.5
      my = (e.clientY - r.top) / r.height - 0.5
      if (!quadro) quadro = window.requestAnimationFrame(desenhar)
    }

    const aoSair = () => {
      mx = 0
      my = 0
      if (!quadro) quadro = window.requestAnimationFrame(desenhar)
    }

    cena.addEventListener('mousemove', aoMover)
    cena.addEventListener('mouseleave', aoSair)
    return () => {
      cena.removeEventListener('mousemove', aoMover)
      cena.removeEventListener('mouseleave', aoSair)
      if (quadro) window.cancelAnimationFrame(quadro)
    }
  }, [ref, reduced, isTouch])
}
